module.exports = __webpack_public_path__ + "img/iconkefushi.b7cfaed3.png";